import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Under-Construction.jpg")